import { all } from 'redux-saga/effects';

import positionSaga from './positionSaga';

export default function* rootSaga() {
  yield all([positionSaga()]);
}
